import React from 'react'
import Translation from '../../global/Translation'
import Modal from '../../global/Modal'
import style from './style/complementary_product_cframe_style.module.scss'
import Button from '../../global/Button'
import ProductImage from '../../catalog/ProductImage'
import ProductDisplayName from '../../global/ProductDisplayName'
import Spinner from '../../global/Spinner'
import DisplayPrice from '../../catalog/rectangleResult/displays/DisplayPrice'

const ComplementaryProductCframe = ({ onClose, cframeProduct, cframeQty, cframeProductError, language }) => {
    if (!cframeProduct && !cframeProductError) {
        return <Spinner isLoading={true} />
    }

    if (cframeProductError || !cframeProduct) {
        onClose()
        return null
    }

    const getCframeInfoPdf = language => {
        switch (language) {
            case 'es': return 'https://offpackcosentino.smartbrochure.es/index.php/files/sharedStaticLink/id/5fc7b447850dab9a32cf1430e060802bb71db190'
            case 'de': return 'https://offpackcosentino.smartbrochure.es/index.php/files/sharedStaticLink/id/5a935115b4559f85c05fe8c34af74dc9eb79d160'
            case 'da': return 'https://offpackcosentino.smartbrochure.es/index.php/files/sharedStaticLink/id/da7ba755de57628ad445dfd713fd59cef8e30f43'
            case 'fi': return 'https://offpackcosentino.smartbrochure.es/index.php/files/sharedStaticLink/id/ec34f48bb1085233c95a964d51c806cf8c5df43a'
            case 'fr':
            case 'fr-CA': return 'https://offpackcosentino.smartbrochure.es/index.php/files/sharedStaticLink/id/62db35c2a1503712a0799ea7fbfc26de186e64c9'
            case 'it': return 'https://offpackcosentino.smartbrochure.es/index.php/files/sharedStaticLink/id/14ad559a1c71bb025531d026827c88b6cd205654'
            case 'ja': return 'https://offpackcosentino.smartbrochure.es/index.php/files/sharedStaticLink/id/597965b63a2392a5c19a73eb00ec46e2e919c534'
            case 'nl': return 'https://offpackcosentino.smartbrochure.es/index.php/files/sharedStaticLink/id/ff19436d61dd4797883efbf9312269533630f647'
            case 'no': return 'https://offpackcosentino.smartbrochure.es/index.php/files/sharedStaticLink/id/e31cd90e160184f0e5ff8fe9c0a93e47f693bbcb'
            case 'pt': return 'https://offpackcosentino.smartbrochure.es/index.php/files/sharedStaticLink/id/b58a614ef2eb289b91c5b3752bc7016db5fdf42d'
            case 'pl': return 'https://offpackcosentino.smartbrochure.es/index.php/files/sharedStaticLink/id/f3c6594715a4c654319751fb92d0f4452f7932c5'
            case 'sv': return 'https://offpackcosentino.smartbrochure.es/index.php/files/sharedStaticLink/id/1ed5388a21bf3476ada78f3061a8f563e01cf711'
            case 'tr': return 'https://offpackcosentino.smartbrochure.es/index.php/files/sharedStaticLink/id/a56ba251bbda135e5cfb440c2c96f6276db272e5'
            case 'en':
            case 'en-CA':
            case 'he':
            default: return 'https://offpackcosentino.smartbrochure.es/index.php/files/sharedStaticLink/id/0d645d05a7fc4d1115c6280e31deb514f4413cc9'
        }
    }

    return (
        <Modal
            title={<Translation id="complementary_product_cframe_title" defaultMessage="Complementary product added:" />}
            onClose={onClose}
            size="large"
            showFooter
            footer={
                <Button inverted onClick={onClose} className={style['complementary-product-cframe__footer-button']}>
                    <Translation id="continue" defaultMessage="Continue" />
                </Button>
            }
        >
            <div className={style['complementary-product-cframe']}>
                <p className={style['complementary-product-cframe__description']}>
                    <Translation
                        id="complementary_product_cframe_description"
                        defaultMessage="To ensure a correct and lasting installation of the flooring pieces you have selected, we have automatically added the following product to your order:"
                    />
                </p>
                <table className={style['complementary-product-cframe__table']}>
                    <thead className={style['complementary-product-cframe__table-head']}>
                        <tr>
                            <th className={style['complementary-product-cframe__table-header']}>
                                <Translation id="product" defaultMessage="Product" />
                            </th>
                            <th className={style['complementary-product-cframe__table-header']}>
                                <Translation id="price" defaultMessage="Price" />
                            </th>
                            <th className={style['complementary-product-cframe__table-header']}>
                                <Translation id="quantity" defaultMessage="Quantity" />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className={style['complementary-product-cframe__table-row']}>
                            <td className={style['complementary-product-cframe__table-cell']}>
                                <div className={style['complementary-product-cframe__product']}>
                                    <ProductImage product={cframeProduct} customClass={style['complementary-product-cframe__product-image']} />
                                    <div className={style['complementary-product-cframe__product-info']}>
                                        <p className={style['complementary-product-cframe__product-name']}>
                                            <ProductDisplayName product={cframeProduct} />
                                        </p>
                                        <span className={style['complementary-product-cframe__product-variant']}>
                                            <Translation id="complementary_product_cframe_box_units" defaultMessage="1 Box: 40 units" />
                                        </span>
                                    </div>
                                </div>
                            </td>
                            <td className={style['complementary-product-cframe__table-cell']}>
                                <span className={style['complementary-product-cframe__product-price']}>
                                    <DisplayPrice product={cframeProduct} displayPriceWithoutMeasure={true} hideMessagesAround={true} showTotalPriceByQty={cframeQty} />
                                </span>
                            </td>
                            <td className={style['complementary-product-cframe__table-cell']}>
                                <span className={style['complementary-product-cframe__product-quantity']}>{cframeQty}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <p className={style['complementary-product-cframe__info-text']}>
                    <Translation
                        id="complementary_product_cframe_info_text"
                        defaultMessage="These are reinforcements that stiffen the L-shaped flooring pieces. They prevent breakage and their correct installation also ensures the L-shaped pieces are guaranteed. The quantity has been calculated based on the number of flooring units you have indicated."
                    />
                </p>
                <a href={getCframeInfoPdf(language)} target="_blank" rel="nofollow noopener noreferrer" className={style['complementary-product-cframe__info-link']}>
                    <Translation id="complementary_product_cframe_info_link" defaultMessage="More information about C-Frame Floor" />
                </a>
                <p className={style['complementary-product-cframe__footer-note']}>
                    <Translation
                        id="complementary_product_cframe_footer_note"
                        defaultMessage="You can adjust the quantity or remove them from the cart before placing your order."
                    />
                </p>
            </div>
        </Modal>
    )
}

export default ComplementaryProductCframe